module.exports = __webpack_public_path__ + "static/quito-605ac9d2e0009a60014111b3bedf73c9.jpg";